import { useEffect, useState } from 'react'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import axios from 'axios'
import placeholder from '../../assets/images/img-placeholder.jpg'
import { useHistory, useLocation } from 'react-router'
import { FaArrowLeft, FaRegTrashAlt } from 'react-icons/fa'
import CargaImage from '../../assets/images/CARGA.png'
import InputCheck from '../../components/Inputs/InputCheck'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import InputNumber from '../../components/Inputs/InputNumber'
import { IoAddSharp } from 'react-icons/io5'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { BarcodeScanner } from 'react-barcode-scanner'
import { BsUpcScan } from 'react-icons/bs'

export const UnloadItemsView = () => {
  const server = process.env.REACT_APP_SERVER_URL

  const { addAlert } = useSnackBars()

  const history = useHistory()

  const location = useLocation()

  const [loading, setLoading] = useState<boolean>(false)

  const [warehouses, setWarehouses] = useState<any[]>([])

  const [selectedItem, setSelectedItem] = useState<any>(null)

  const [itemsLists, setItemLists] = useState<any[]>([])

  const [amount, setAmount] = useState<any>(0)

  const [checked, setChecked] = useState<boolean>(false)

  const warehouse = location.state as any

  const [showBarCode, setshowBarCode] = useState<boolean>(false)

  const [result, setResult] = useState('')

  const getData = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${server}/inventory/warehouse`)
      setWarehouses(res.data.warehouses)
    } catch (error: any) {
      console.log(error?.message)
    }
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  const loadToInventory = async () => {
    //console.log(listedInventoryProducts)

    if (itemsLists.length <= 0) {
      // Alert.alert("Error", "Agrega algún producto para cargar", [{text: "Aceptar"}])
      return
    }

    console.log('ITEMS LIST', itemsLists)

    const location: any = {
      id: warehouse.id,
      locationType: warehouse.warehouseType,
    }

    let itemsRegular: any[] = []

    itemsRegular = itemsLists.map((item: any) => ({
      idItem: item.id,
      amount: item.amount,
    }))

    /* itemsList.forEach((item: {product: IProduct, amount: number}) => {
        if (item.product.type === "FINISHED_PRODUCT") {
          itemsFinishedProducts.push({idItem: item.product.id, amount: item.amount})
        } else {
          itemsRegular.push({idItem: item.product.id, amount: item.amount})
        }
      }); */

    const bodyRegular: any = {
      destination: location,
      accounting: checked,
      items: itemsRegular,
    }

    setLoading(true)
    try {
      if (itemsRegular) {
        const resRegular = await axios.post(
          `${server}/inventory/unload`,
          bodyRegular
        )
        addAlert({
          message: 'Productos descargados correctamente',
          status: 'success',
        })
        //console.log(resRegular.data)
      }

      /* if (itemsFinishedProducts) {
              const resFinishedProducts = await axiosInstance.post("/inventory/finished-product", bodyFinishedProducts ,{headers: { 'Authorization': token}})
              console.log(resFinishedProducts.data)
            } */

      history.push('/inventory')
    } catch (error: any) {
      console.log(error?.message)
      addAlert({
        message: 'No se pudieron descargar los productos',
        status: 'error',
      })
      // Alert.alert("Error", "No se pudieron cargar los productos", [{text: "Aceptar"}]);
    }
    setLoading(false)
  }

  console.log('ITEMS', itemsLists)

  return (
    <div className="h-full">
      {showBarCode && (
        <BarcodeScanner
          options={{
            delay: 1000,
            formats: [
              'qr_code',
              'code_128',
              'code_39',
              'code_93',
              'codabar',
              'ean_13',
              'ean_8',
              'itf',
              'upc_a',
              'upc_e',
            ],
          }}
          onCapture={(value: any) => {
            if (value?.length > 0) {
              setResult(value[0]?.rawValue)
              setshowBarCode(false)
              // console.log('VALUE', value[0])
              // window.alert(JSON.stringify(value[0]?.rawValue))
            }
          }}
        />
      )}

      {!showBarCode && (
        <>
          <div className="flex flex-row justify-between items-center">
            <FaArrowLeft
              style={{ color: '#2961D0' }}
              onClick={() => history?.push('/inventory')}
            />
          </div>

          <div className="mt-5">
            <label className="font-medium">Descargar artículos</label>
          </div>

          <div className="mt-5">
            {itemsLists?.map((item) => (
              <div className="flex flex-row justify-between">
                <div className="flex flex-col">
                  <label className="font-normal text-sm">{item?.name}</label>
                  <label className="font-normal text-sm">{item?.sku}</label>
                </div>

                <div className="text-center" style={{ width: '15%' }}>
                  <label className="font-normal">{item?.amount}</label>
                </div>

                <div
                  className="flex flex-row justify-center items-center"
                  style={{ width: '10%' }}
                >
                  <FaRegTrashAlt
                    style={{ color: 'red' }}
                    onClick={() => {
                      setItemLists((prevItems) =>
                        prevItems?.filter((x) => x?.id !== item?.id)
                      )
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-5 flex flex-col items-center">
            <img
              src={CargaImage}
              alt="zerux"
              style={{ height: 120, width: 200 }}
            />

            <label
              style={{
                color: '#919191',
                width: '70%',
                textAlign: 'center',
                marginTop: -1,
                fontSize: 15,
              }}
            >
              Agrega artículos para descargarlos de su existencia
            </label>
          </div>

          <div className="mt-6">
            <InputCheck
              classes="w-52 h-10"
              value={checked}
              label={'Generar asiento contable'}
              helperFunction={(value) => setChecked(value)}
            />
          </div>

          <div className="flex flex-row justify-between items-center">
            <div style={{ width: '50%' }} className="-mt-2">
              <RawAutoComplete
                label="Artículo"
                url={`inventory/item/simple-search`}
                bodyGet={'items'}
                queryParam={'param'}
                selectedValue={selectedItem}
                setSelectedValue={(value) => {
                  setSelectedItem(value)
                }}
                defaultSearch={result}
              />
            </div>

            <div className="mt-2">
              <BsUpcScan size={25} onClick={() => setshowBarCode(true)} />
            </div>

            <div style={{ width: '30%' }}>
              <InputNumber
                small
                label="Cantidad"
                onChange={(value) => {
                  console.log('VALUE', value)
                  setAmount(value)
                }}
                value={amount}
              />
            </div>

            <div className="mt-3">
              <div
                className="bg-primary"
                style={{ padding: 5, borderRadius: 8 }}
                onClick={() => {
                  if (amount === 0) {
                    addAlert({
                      message: 'La cantidad debe de ser mayor a cero',
                      status: 'error',
                    })
                    return
                  }

                  if (!selectedItem) {
                    addAlert({
                      message: 'El artículo es requerido',
                      status: 'error',
                    })
                    return
                  }
                }}
              >
                <IoAddSharp color="white" />
              </div>
            </div>
          </div>

          <div className="flex flex-row justify-center mt-5">
            <Button type="primary" onClick={loadToInventory}>
              Descargar inventario
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
